import { Typography, TypographyProps, styled } from "@mui/material";

const NormalTypography = styled(Typography)<TypographyProps>(({ theme }) => ({
    color: "#000000",
    fontSize: '12px',
    fontWeight: 600
}));

export default NormalTypography